module.exports = __webpack_public_path__ + "static/media/arrow-white.e49a6a4a.svg";